import React, { useRef, useState, useEffect } from "react";
import { Row, Col, Form, Input, Button, Modal, Checkbox } from "antd";
import loginRules from './index.validation';
import loginSide from "../../assets/images/login.svg";
import logoSmall from "../../assets/images/logo/logo.svg";
import { UserLogin } from '../../redux/Login/LoginActions';
import store from '../../redux/store';
import * as actions from "../../redux/Login/LoginTypes";

export default function Login() {
  const [spinStatus, setSpinStatus] = useState(false);
  const formRef = useRef();

  const handleLogin = async () => {
    const userName = formRef.current.getFieldValue("userName");
    const password = formRef.current.getFieldValue("password");

    if (userName && password) {
      const userData = { userName: userName, password: password };
      store.dispatch({ type: actions.LOGIN, payload: userData });

      setSpinStatus(true);
      const result = await UserLogin(userData);
      setSpinStatus(false);

      if (result?.msg != "success") {
        Modal.error({ content: result.msg });
      };
    };
  };

  useEffect(() => {
    return () => {
      setSpinStatus(false);
    };
  }, []);

  return (
    <Row gutter={[32, 0]} className="hp-authentication-page">
      <Col lg={12} span={24} className="hp-py-sm-0 hp-py-md-64">
        <Row className="hp-h-100" align="middle" justify="center">
          <Col xxl={11} xl={15} lg={20} md={20} sm={24} className="hp-px-sm-8 hp-pt-24 hp-pb-48 hp-text-center">
            <img src={logoSmall} alt="Logo" width="180" class="hp-mb-24 " />
            <h2 className="hp-mb-sm-0 hp-text-color-primary-1 hp-text-color-dark-0 hp-text-center">Budy Professional Services</h2>
            <p className="hp-mt-sm-0 hp-mt-8 hp-text-color-black-60 hp-text-center">Very good works are  waiting for you 🤞</p>
            <Form ref={formRef} layout="vertical" name="basic" initialValues={{ remember: true }} className="hp-mt-sm-16 hp-mt-32" onFinish={handleLogin}>
              <Form.Item name="userName" label="Username :" className="hp-mb-16" rules={loginRules.userName}>
                <Input placeholder="Enter Username" />
              </Form.Item>
              <Form.Item name={"password"} label="Password :" className="hp-mb-16" rules={loginRules.password}>
                <Input.Password placeholder="Enter Password" />
              </Form.Item>
              {/* <Row gutter={32} justify="space-between" className="hp-mb-16">
                <Col>
                  <Checkbox >Remember Me</Checkbox>
                </Col>
                <Col>
                  <Link to="/forgotpassword">Forgot Password?</Link>
                </Col>
              </Row> */}
              <Button style={{ marginTop: "10px" }} htmlType="submit" block type="primary" loading={spinStatus}>Sign in</Button>
            </Form>
          </Col>
        </Row>
      </Col>
      <Col lg={12} span={24} className="hp-bg-color-primary-4 hp-bg-color-dark-90 hp-position-relative">
        <Row className="hp-image-row hp-h-100 hp-px-sm-8 hp-px-md-16 hp-pb-sm-32 hp-pt-md-96 hp-pt-md-32">
          <Col span={24}>
            <Row align="middle" justify="center" className="hp-h-100">
              <Col md={20} span={24} className="hp-bg-item hp-text-center hp-mb-md-32">
                <img src={loginSide} alt="Logo" width="900" className=" hp-position-relative" style={{ zIndex: "999" }} />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};